import { render, staticRenderFns } from "./LeadNotes.vue?vue&type=template&id=79acddee&scoped=true"
import script from "./LeadNotes.vue?vue&type=script&lang=js"
export * from "./LeadNotes.vue?vue&type=script&lang=js"
import style0 from "./LeadNotes.vue?vue&type=style&index=0&id=79acddee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79acddee",
  null
  
)

export default component.exports